import React, { useEffect } from "react";
import LoadingIndicator from "../../../calendar/components/LoadingIndicator";
import Pagination from "../../component/Pagination";
import Card from "../../theme/untitled/Card/Card";
import Table from "../../theme/untitled/Table/Table";
import EmptyState from "../../theme/untitled/EmptyState/EmptyState";
import { durationToString } from "../../tools";
import { formatter_ymdhm } from "../../../../helpers/formatters";
import { Link } from "react-router-dom";
import styles from "./Imports.module.scss";

/**
 *
 * @param {object} imports
 * @param {array} integrations
 * @param {function} fetchImports
 * @returns {Element}
 * @constructor
 */
const Imports = ({ integrations, fetchImports, imports }) => {
  /**
   *
   */
  useEffect(() => {
    fetchImports(1);
  }, []);

  const columns = [
    {
      key: "created",
      header: "Date",
      render: (row) => formatter_ymdhm.format(row.created * 1000),
    },
    {
      key: "integration",
      header: "Integration",
      render: (row) =>
        integrations.find((i) => i.uuid == row.integration_uuid)?.name ||
        "-",
    },
    {
      key: "duration",
      header: "Duration",
      render: (row) => durationToString(row.duration),
    },
    {
      key: "events_imported_count",
      header: "No. of synced events",
      render: (row) => row.data.events_imported_count,
    },
  ];

  const importsPagination =
    imports.collection.length && imports.pagination.pageCount > 1 ? (
      <Pagination
        total={imports.pagination.count}
        currentPage={imports.pagination.page}
        itemsPerPage={imports.ipp}
        onPageChange={fetchImports}
        getPageUrl={() => ""}
      />
    ) : null;

  const totalImportsInfo = imports.total ? `${imports.total} in total` : null;

  return (
    <Card>
      <Card.Header
        id="imports-card-title"
        title="Recent integration syncs"
        subtitle={totalImportsInfo}
      />
      <Card.Body noPadding>
        {imports.fetch ? (
          <LoadingIndicator />
        ) : (
          <div className={styles.tableScroll}>
            <Table
              columns={columns}
              rows={imports.collection}
              emptyState={
                <EmptyState
                  title="No data"
                  body={
                    <>
                      <Link to="/integrations">Go to integrations</Link>, and
                      synchronize the calendar events data.
                    </>
                  }
                />
              }
            />
          </div>
        )}
      </Card.Body>
      {importsPagination && <Card.Footer>{importsPagination}</Card.Footer>}
    </Card>
  );
};

export default Imports;
